<template>
<v-navigation-drawer class="drawer-fix" fixed app :permanent="$vuetify.breakpoint.mdAndUp" light :mini-variant.sync="$vuetify.breakpoint.mdAndUp && mini" :clipped="$vuetify.breakpoint.mdAndUp" :value="mini">
  <v-toolbar flat class="transparent">
    <v-list class="pa-0">
      <v-list-tile avatar>
        <v-list-tile-avatar v-if="$vuetify.breakpoint.mdAndUp && mini">
          <v-btn icon @click.native.stop="navToggle" class="mx-0">
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-avatar v-else>
          <v-btn icon color="blue lighten-4" class="mx-0 headline font-weight-light white--text" :to="{ name: 'perfil' }">
            <v-icon color="blue accent-4">person</v-icon>
          </v-btn>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ name }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon @click.native.stop="navToggle">
            <v-icon>chevron_left</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-toolbar>

  <v-list class="py-0" dense v-for="(group, index) in items" :key="index">
    <!--<v-divider class="mb-2" :class="{ 'mt-0': !index, 'mt-2': !!index }" v-if="auth && group[0].roles.includes(auth.role)"></v-divider>-->
    <div v-for="item in group" :key="item.title">
      <div v-if="auth && item.roles.includes(auth.role)">
      <v-list-group v-if="!!item.items" :prepend-icon="item.icon" no-action>
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-for="subItem in item.items" :key="subItem.title" @click="subItem.action ? subItem.action() : false" :to="subItem.to" ripple :exact="subItem.exact !== undefined ? subItem.exact : true">
          <v-list-tile-content>
            <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon>{{ subItem.icon }}</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list-group>
      <v-list-tile v-else @click.native="item.action ? item.action() : false" href="javascript:void(0)" :to="item.to" ripple :exact="item.exact !== undefined ? item.exact : true">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      </div>
    </div>
  </v-list>

  <v-divider></v-divider>

  <v-list>
    <v-list-tile>
      <v-list-tile-action>
        <v-switch
          v-model="auth.live_mode"
          color="green"
          @change="changeLiveMode"
        ></v-switch>
      </v-list-tile-action>
      <v-list-tile-title>Entorno de Producción</v-list-tile-title>
    </v-list-tile>
  </v-list>
</v-navigation-drawer>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { api } from '~/config'
import Form from '~/mixins/form'

export default {
  mixins: [Form],

  data: () => ( {
    items: [],
    name: null,
  } ),

  props: [ 'mini' ],

  computed: {
    ...mapGetters({
      auth: "auth/user"
    }),
  },

  watch: {
    authName( val ) {
      if ( val ) {
        this.name = val
      }
    },
  },

  mounted() {
    this.name = this.auth.name
    if(this.name.length > 16) {
      this.name = this.name.substring(0,16) + '...'
    }
    this.navigation()
  },

  methods: {
    navToggle() {
      this.$emit( 'navToggle' )
    },

    async logout() {
      await this.$store.dispatch( 'auth/logout' )

      this.$toast.info( 'Hasta la próxima.' )
      this.$router.push( {
        name: 'login'
      } )
    },

    changeLiveMode() {
      axios
        .put(api.path('perfil.live_mode'), {
          live_mode: this.auth.live_mode
        })
        .then(res => {
          this.$store.dispatch('auth/fetchUser')
          this.$toast.success('Se actualizó el estado del entorno.')
        })
        .catch(err => {
          this.handleErrors(err.response.data.errors)
        })
        .then(() => {
        })
    },

    navigation() {
      this.items = [
        [ {
          title: 'Panel',
          icon: 'dashboard',
          to: {
            name: 'panel'
          },
          exact: false,
          roles: [ 'Administrador', 'Escolares' ]
        } ],
        [ {
          title: 'Lotes de Títulos',
          icon: 'school',
          to: {
            name: 'lotes-titulos'
          },
          exact: false,
          roles: [ 'Administrador', 'Escolares' ]
        } ],
        [ {
          title: 'Lotes de Certificados',
          icon: 'book',
          to: {
            name: 'lotes-certificados'
          },
          exact: false,
          roles: [ 'Administrador', 'Escolares' ]
        } ],
        [ {
          title: 'Programas de Estudio',
          icon: 'description',
          to: {
            name: 'programa'
          },
          exact: false,
          roles: [ 'Administrador', 'Escolares' ]
        } ],
        [ {
          title: 'Planteles',
          icon: 'business',
          to: {
            name: 'campus'
          },
          exact: false,
          roles: [ 'Administrador']
        } ],
        [ {
          title: 'Carreras',
          icon: 'list',
          to: {
            name: 'carrera'
          },
          exact: false,
          roles: [ 'Administrador']
        } ],
        [ {
          title: 'Responsables',
          icon: 'people',
          to: {
            name: 'responsables'
          },
          exact: false,
          roles: [ 'Administrador']
        } ],
        [ {
          title: 'Usuarios',
          icon: 'contacts',
          to: {
            name: 'usuario'
          },
          exact: false,
          roles: [ 'Administrador']
        } ],
        [ {
          title: 'Configuración',
          icon: 'settings',
          to: {
            name: 'configuracion'
          },
          exact: false,
          roles: [ 'Administrador']
        } ],
        [ {
          title: 'Cerrar Sesión',
          icon: 'exit_to_app',
          action: this.logout,
          roles: [ 'Administrador', 'Escolares' ]
        } ]
      ]
    }
  }
}
</script>

<style>
	/*.drawer-fix {
    z-index: 202 !important;
	}*/
</style>